import * as fp from 'lodash/fp';
import { connect } from 'react-redux';
import container from 'src/ServiceContainer';
import { TenantConfigViewItem, TenantConfigViewData, isViewDefnLoaded } from 'src/dao/tenantConfigClient';
import { reorderWithSortBy } from 'src/pages/Hindsighting/CategoryRecap/Productivity/Productivity.selectors';
import { requestViewDefn, receiveViewDefn, receiveError } from './Productivity.slice';
import { Productivity, ValueProps, FunctionProps } from './Productivity';
import { getLocalConfig } from 'src/components/Subheader/Favorites/Favorites.utils';
import { FavoriteListItemStorage } from 'src/components/Subheader/Favorites/Favorites.types';
import type { ProductivityOwnProps } from 'configuration-schemas/ownProps';
import { cloneDeep, flow } from 'lodash';
import { AppState, AppThunkDispatch } from 'src/store';
import { isDataLoaded } from 'src/services/pivotServiceCache';
import { ComponentErrorType } from 'src/components/ErrorBoundary/ErrorBoundary.slice';
import { ConfDefnComponentType } from 'configuration-schemas/confdefnComponents';
import { AppType } from 'configuration-schemas/general';
import { zProductivityViewDefn } from 'configuration-schemas/viewdefns/viewdefn';

function mapStateToProps(state: AppState, ownProps: ProductivityOwnProps): ValueProps {
  const { title, defns } = ownProps;
  const viewState = state.pages.hindsighting.productivity;
  const { viewDefnState, viewDataState, viewDefn, unmodifiedViewDefn } = viewState;

  const chartConfig: TenantConfigViewItem = fp.get('viewDefn.view[0]', viewState)
    ? viewState.viewDefn.view[0]
    : { dataIndex: '__', text: '__' };
  const carouselView: TenantConfigViewItem[] = fp.get('viewDefn.view[1].view', viewState)
    ? viewState.viewDefn.view[1].view || [] // Necessary to appease typesystem.
    : [];

  const loaded = isViewDefnLoaded(viewDefnState) && isDataLoaded(viewDataState);
  const data = reorderWithSortBy(state);

  return {
    title,
    groupByViewDefnStr: defns.subheader.groupBy,
    sortByViewDefnStr: defns.subheader.sortBy,
    loaded,
    chartConfig,
    carouselView,
    data,
    groupBy: state.subheader.groupBy,
    sortBy: state.subheader.sortBy,
    flowStatus: state.subheader.flowStatus,
    viewDefn,
    unmodifiedViewDefn,
    viewDataState,
  };
}

function dispatchToProps(dispatch: AppThunkDispatch, ownProps: ProductivityOwnProps): FunctionProps {
  const { defns } = ownProps;
  return {
    onShowView() {
      dispatch(requestViewDefn());
      container.tenantConfigClient
        .getTenantViewDefnsWithFavorites({
          defnIds: defns.view,
          appName: AppType.Assortment,
          validationSchemas: [zProductivityViewDefn],
        })
        .then(async (resp) => {
          const unmodifiedViewDefn = cloneDeep(resp[0]);
          const view = unmodifiedViewDefn.view[1].view;
          if (view) {
            const localConfig: FavoriteListItemStorage | undefined = await getLocalConfig(
              defns.view[0],
              (resp as any)[defns.view.length],
              dispatch,
              unmodifiedViewDefn.view[1] as unknown as TenantConfigViewData,
              () => view.map((x) => x.dataIndex),
            );
            if (localConfig && localConfig.config) {
              resp[0].view[1] = localConfig.config as any;
            }
            resp[1] = unmodifiedViewDefn;
          }
          return resp;
        })
        .then((resp) => {
          dispatch(
            receiveViewDefn({
              viewDefn: resp[0],
              unmodifiedViewDefn: resp[1],
            }),
          );
        })
        .catch((error) =>
          dispatch(
            receiveError({
              type: ComponentErrorType.config,
              message: (error as Error)?.message,
              name: ConfDefnComponentType.productivity,
              stack: (error as Error)?.stack,
              issues: error,
              defnId: error.defnId,
            }),
          ),
        );
    },
    onUpdateConfig(config: TenantConfigViewData) {
      dispatch(
        receiveViewDefn({
          viewDefn: config,
        }),
      );
    },
  };
}

const sensitiveView = flow(() => Productivity)();

export default connect(mapStateToProps, dispatchToProps)(sensitiveView);
